module.exports = {
	"articleTitle1": "Best Indian: Cardamom ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Caradamom",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/content/best-ann-arbor-jerusalem-garden",
	"articleSnippet1": "Apr 2, 2017 ... Cardamom is, incontestably, the culinary jewel of North Campus.",
	"articleSnippet2": "Apr 9, 2008 ... It's also the only restaurant within walking distance of campus to offer authentic \nTurkish coffee with cardamom. Jerusalem Garden is a special ...",
	"foodRecommendations": [
		{
			"text": "Hard to go wrong with the food here, don't be afraid to try the goat",
			"person": "Nick Kortman"
		}
	],
	"articleTitle2": "The Best of Ann Arbor: Jerusalem Garden",
	"address": "1739 Plymouth Rd, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170407/cardamomonline.jpg?itok=V6kROyAO",
			"author": "Robert Buechler",
			"caption": ""
		}
	],
	"position": {
		"lat": 42.298483,
		"lng": -83.721366
	},
	"totalMisc": 1,
	"categories": {
		"bestofaa": 1,
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/cardamom.json
// module id = 843
// module chunks = 0